import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
  htmlTooltip: {
    backgroundColor: '#383838',
    color: '#82c832 !important',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    borderRadius: "10px",
    opacity: "1",
    '& b': {
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  
  myPointTooltip: {
    backgroundColor: '#383838',
    color: '#82c832 !important',
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    borderRadius: "10px",
    opacity: "1",
    '& b': {
      fontWeight: theme.typography.fontWeightMedium,
    },
  }
});

class MakeVideoTooltip extends React.Component {
  state = {
    arrowRef: null,
  };

  handleArrowRef = node => {
    this.setState({
      arrowRef: node,
    });
  };

  render() {
    const { classes, classesKey, children, placement, content: ContentComponent } = this.props;
    return (
      <Tooltip
        // open ={true}
        id={this.props.id}
        classes={{ tooltip: classes[classesKey ? classesKey : "htmlTooltip"] }}
        interactive={true}
        placement={placement}
        title={
          <React.Fragment>
            {typeof ContentComponent === 'object' ? ContentComponent : <ContentComponent />}
          </React.Fragment>
        }
        enterDelay={300}
      >
        {children}
      </Tooltip>
    );
  }
}

export default withStyles(styles)(MakeVideoTooltip);